import React, { useState } from "react";
import styled from "styled-components";
import Icon from "../../components/Icon/Icon";
import { HorizontalAlignment } from "../../../components/types";
import { Device } from "../../../components/device";
import { Waypoint } from "react-waypoint";
import Rating from "../Rating/Rating";

//Used to insert a quote text & quote author.

//Properties:
//Quote text
//Author
//Horizontal alignment

//Usage:
/*
<Quote
    author="Lance Armstrong"
    horizontalAlign="center"
    backgroundImage="https://www.heyday.dk/media/1293/topbanner-1.jpg">
    <p>A boo is a lot louder than a cheer.</p>
</Quote>
*/

interface QuoteProps {
    horizontalAlign?: HorizontalAlignment;
    author?: string;
    backgroundImage?: string;
    ratingValue?: number;
    maxRatingValue?: number;
    starColor?: string;
}

const QuoteWrap = styled.blockquote<QuoteProps>`
    position: relative;
    margin-bottom: 1.5rem;
    text-align: ${props =>
        (props.horizontalAlign === "left") ? "left" :
            (props.horizontalAlign === "center") ? "center" :
                (props.horizontalAlign === "right") ? "right" :
                    "inherit" };
`;

const QuoteText = styled.div`
    font-family: var(--font-josefin-sans, 'Josefin Sans', sans-serif);
    font-size: 2rem;
    letter-spacing: .025;
    line-height: 1.15;
    ${Device.laptop} {
        font-size: 3rem;
    }
`;

const QuoteFooter = styled.footer`
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 1.5rem 0.5rem;
`;

const QuoteCite = styled.cite`
    font-style: normal;
    text-transform: uppercase;
    margin-left: 0.3rem;
    max-width: 190px;
`;

const QuoteAuthor = styled.span`
    font-size: var(--text-xs, .7333rem);
    letter-spacing: 0.025em;
    margin-bottom: .5rem;
    font-weight: bold;
`;

const Dash = styled.span`
    display: inline-block;
    background-color: currentColor;
    height: 1px;
    width: 0.5rem;
    margin-top: 0.75rem;
`;

const QuoteBg = styled.img`
    box-sizing: border-box;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
    object-fit: contain;
    z-index: -1;
`;

const Quote: React.FC<QuoteProps> = (props) =>
{
    //In view state
    const [inView, setInView] = useState(false);

    return(
        <Waypoint
            onEnter={() => setInView(true)}
            onLeave={() => setInView(false)}
            bottomOffset={-200}>
            <QuoteWrap {...props}>
                {props.ratingValue && props.maxRatingValue ?
                    <Rating
                        value={props.ratingValue}
                        maxValue={props.maxRatingValue}
                        isQuote={true}
                        starColor={props.starColor} />
                    : null }
                {props.backgroundImage && inView ? <QuoteBg src={props.backgroundImage} /> : null }
                <QuoteText>"{props.children}"</QuoteText>
                {props.author ?
                    <QuoteFooter>
                        <Dash />
                        <QuoteCite>
                            <QuoteAuthor>{props.author}</QuoteAuthor>
                        </QuoteCite>
                    </QuoteFooter>
                    : null }
            </QuoteWrap>
        </Waypoint>
    );
};

export default Quote;